import MainFrame from './MainFrame';

export default MainFrame;
